<template>
  <div class="footer">
    <div class="public">
      <el-row>
        <el-col :span="10">
          <div class="footer-logo">
            <img src="//cdnw2.acmcoder.com/release/exam/2.0.1/images/wlogo.png" />
          </div>
          <div class="text">丈量，不可估量的未来</div>
        </el-col>
        <el-col :span="14">
          <div class="footer-txt">
            <router-link to="/link/about">关于我们</router-link> |
            <router-link to="/link/about?to=concat-user">联系我们</router-link>
            | <router-link to="/link/state">免责声明</router-link> | 
            <secrect-control :onlyYingshi="true"/>
            <div class="copy-right" v-html="webconfig.copy">
              Copyright © acmcoder.com<br />All Rights Reversed
              京ICP备15012255-1
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16">
          <div class="foot-right">
            <div class="footer-qq gehe" style="position: relative; text-align: center;">
              <div style="text-align: right">考生客服</div>
              <div
                style="color: #29bdb9; text-align: right"
                v-html="webconfig.customerService"
              >
                0851-88622569 010-85359782
              </div>
              <div class="radus" @click="Onqq">
                <span v-html="webconfig.qq2"></span> &nbsp;<i
                  class="iconfont iconQQ"
                ></i>
              </div>
            </div>
            <div class="footer-qq" style="position: relative; text-align: center;">
              <div>企业咨询</div>
              <div style="color: #29bdb9" v-html="webconfig.Landline">
                400-060-8006
              </div>
              <div class="radus" @click="Onqq">
                <i class="iconfont iconQQ"></i> &nbsp;<span
                  v-html="webconfig.qq"
                ></span>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="footer-ewm">
            <img src="//cdnw2.acmcoder.com/release/www/2.0.1/images/ewm.png" />
            <div>企业微信</div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      webconfig: {
        // "Landline":"400-060-8006",
        // "customerService":"010-85359782",
        // "qq":"533869549"
      },
    }
  },
  computed: {
    loadConfig() {
      return this.$store.state.app.config
    },
  },
  mounted() {
    if (this.$store.state.app.config && this.$store.state.app.config.concat) {
      this.webconfig = this.$store.state.app.config.concat
      this.judgeDomainCopyRight()
      this.judgeCustomerService()
    }
  },
  watch: {
    loadConfig(newVal, oldVal) {
      if (newVal.concat) {
        this.webconfig = newVal.concat
        this.judgeDomainCopyRight()
        this.judgeCustomerService()
      }
    },
  },
  methods: {
    judgeCustomerService(){
      if (this.webconfig.customerService) {
        if (this.webconfig.customerService[this.domain]) {
          this.webconfig.customerService = this.webconfig.customerService[
            this.domain
          ]
        } else {
          this.webconfig.customerService = this.webconfig.customerService[
            'default'
          ]
        }
      }
    },
    judgeDomainCopyRight(){
      const hostname = location.host;
      const arr = hostname.split('.');
      let domain = '';
      if(arr.length > 2){
        domain = arr.slice(1).join('.');
      }
      else {
        domain = arr.join('.');
      }
      domain = domain.replace(/\./g, '_')
      this.domain = domain;
      if (this.webconfig.copy[domain]) {
        this.webconfig.copy = this.webconfig.copy[domain]
      } else {
        this.webconfig.copy = this.webconfig.copy['default']
      }
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return decodeURI(r[2]);
      } else {
        return null;
      }
    },
    Onqq() {
      window.open('tencent://message/?uin=10987654321')
    },
  },
}
</script>

<style lang="scss" scoped>
.footer {
  // bottom: 0px;
  width: 100%;
  border-top: 1px solid #fff;
  background: #3d444c;
  margin-top: 0px;
  color: #fff;
  font-family: 'Microsoft Yahei';
  .public {
    margin: 0px auto;
    padding: 30px 20px;
    a {
      color: #fff;
    }
    .text {
      opacity: 1;
    }
    .footer-logo {
      width: 140px;
      opacity: 1;
      text-align: center;
      padding: 0px 0px 5px;
      img {
        width: 110px;
      }
    }
    .footer-txt {
      line-height: 25px;
      padding: 16px 20px 0 20px;
      font-size: 14px;
      a {
        text-decoration: none;
      }
      .copy-right {
        padding: 10px 0px 0px;
        color: #999;
      }
    }
    .foot-right {
      font-size: 14px;
      display: flex;
      margin-left: -10px;
    }
    .footer-ewm {
      text-align: center;

      font-size: 14px;
      img {
        width: 80px;
      }
    }
    .footer-qq {
      padding: 0px 20px 20px 15px;
      line-height: 32px;
      float: right;
      height: 110px;
      display: block;
      .radus {
        color: #fff;
        padding: 2px 6px;
        border: 1px solid #fff;
        border-radius: 20px;
        margin-top: 10px;
        line-height: 24px;
        display: flex;
        span {
          margin: auto;
        }
      }
      &.gehe {
        border-right: 1px solid rgba(255, 255, 255, 0.2);
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .footer {
    .public {
      width: 100%;
      font-size: 13px;
      .footer-txt {
        font-size: 12px;
        padding: 0px 0px 20px 20px;
      }
      .foot-right {
        .footer-qq {
          padding: 0px 10px 0px 10px;
          float: left;
          font-size: 10px;
        }
        .footer-ewm {
          padding: 0px 0px 0px 10px;
        }
      }
    }
  }
}
@media screen and (min-width: 600px) and (max-width: 1024px) {
  .footer {
    .public {
      .el-col-10 {
        width: 60%;
        text-align: center;
        .footer-logo {
          width: initial;
          img {
            width: 150px;
          }
        }
      }
      .el-col-14 {
        width: 40%;
      }
      .el-col-16 {
        width: 60%;
        margin-top: 10px;
        position: relative;
        .foot-right {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          margin-left: 0;
        }
      }
      .el-col-8 {
        margin-top: 15px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/footer/mobile.vue